const UNITS = ["KB", "MB", "GB"];

const numberFormatter = new Intl.NumberFormat("pt-BR", {
	maximumFractionDigits: 1,
});

export function formatFileSize(bytes: number): string {
	if (!Number.isFinite(bytes) || bytes < 1024) {
		const value = Math.max(0, Math.round(bytes || 0));
		return value === 1 ? "1 byte" : `${value} bytes`;
	}
	let value = bytes / 1024;
	let unit = 0;
	while (value >= 1024 && unit < UNITS.length - 1) {
		value /= 1024;
		unit += 1;
	}
	return `${numberFormatter.format(value)} ${UNITS[unit]}`;
}
